export class ListTableMaintenanceRunsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<MaintenanceRun>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTableMaintenanceRunsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
